import { z } from 'zod';

export const formSchema = z.object({
  carrierIds: z.array(z.string()).optional(),
  companyIds: z.array(z.string()).optional(),
  orderId: z.string().optional(),
  date: z.object({
    from: z.date().optional(),
    to: z.date().optional(),
  }).optional(),
  nfNumber: z.string().optional(),
});

export type FormSchema = z.infer<typeof formSchema>;